import { AlertFactory } from 'alerts/Alert'
import JobViewModel from 'jobs/views/JobRoot/Job/JobViewModel'
import { ConversationViewModelPort } from 'messaging/components/ConversationView/ConversationViewModel'
import ConversationStore from 'messaging/ConversationStore'

export default function JobConversationViewModelAdapter(
  newAlert: AlertFactory,
  conversationStore: ConversationStore,
  jobViewModel: JobViewModel,
): ConversationViewModelPort {
  return {
    newAlert,
    fetchMessages: conversationStore.fetchMessages,
    sendMessage: jobViewModel.hasConversationManagePermission
      ? conversationStore.sendAdminMessage.bind(conversationStore)
      : conversationStore.sendMessage.bind(conversationStore),
    updateMessage: conversationStore.updateMessage.bind(conversationStore),
    markAsRead: conversationStore.markAsRead,
    toggleMute: conversationStore.toggleMute,
    jobProgressionAdapter: {
      canUpdateJobProgressionAsClient:
        jobViewModel.canUpdateJobProgressionAsClient,
      viewApproveDraftInReviewDialog:
        jobViewModel.approveDraftInReviewDialogVM.show,
      viewRejectDraftInReviewDialog:
        jobViewModel.rejectDraftInReviewDialogVM.show,
    },
  }
}
